<template>
  <div class="sv-page">
    <header class="sv-page-header">
      <div>
        <span class="sv-page-header__eyebrow">Indicadores do processamento</span>
        <h1>Performance</h1>
        <p>Visualize o desempenho diário dos uploads e a distribuição das gravações por horário.</p>
      </div>
    </header>

    <div class="row">
      <div class="col-lg-4">
        <SummaryDay />
      </div>
      <div class="col-lg-4">
        <UploadSuccessCard />
        <UploadErrorCard />
      </div>
      <div class="col-lg-4">
        <UploadTotalSize />
        <UploadTotalDuration />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <UploadTotalsHour />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions } from 'vuex';

import SummaryDay from "../../components/Performance/SummaryDay.vue";
import UploadSuccessCard from "../../components/Performance/UploadSuccessCard.vue";
import UploadErrorCard from "../../components/Performance/UploadErrorCard.vue";
import UploadTotalSize from "../../components/Performance/UploadTotalSize.vue";
import UploadTotalDuration from "../../components/Performance/UploadTotalDuration.vue";
import UploadTotalsHour from "../../components/Performance/UploadTotalsHour.vue";

export default defineComponent({
  name: "PerformancePage",
  components: {
    SummaryDay,
    UploadErrorCard,
    UploadSuccessCard,
    UploadTotalSize,
    UploadTotalDuration,
    UploadTotalsHour,
  },
  methods: {
    ...mapActions([
      "setPerformance"
    ]),
  },
  mounted() {
    this.setPerformance();
  },
});
</script>
